import { forwardRef, type Ref, type SVGProps } from "react";
const IconUserGroupOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M12 8a4 4 0 0 1 4 4.06v1.23a6.44 6.44 0 0 1-2 4.35 2 2 0 0 0 1 3.43l1.73.33c3 .73 3.25 1.9 3.25 3.46V28H4v-3.14c0-1.57.24-2.74 3.25-3.46L9 21a2 2 0 0 0 .95-3.41A6.33 6.33 0 0 1 8 13.29v-1.24A4 4 0 0 1 12 8m0-2a6 6 0 0 0-6 6.06v1.23a8.34 8.34 0 0 0 2.54 5.79l-1.71.37c-4 1-4.83 3-4.83 5.41v3.43A1.72 1.72 0 0 0 3.71 30h16.58A1.72 1.72 0 0 0 22 28.29v-3.43c0-2.39-.79-4.45-4.83-5.41l-1.77-.34a8.4 8.4 0 0 0 2.6-5.82v-1.23A6 6 0 0 0 12 6"
    />
    <path
      fill="currentColor"
      d="M29 30h-4a1 1 0 0 1 0-2h3v-5.1c0-2.15-.67-3.64-4-4.44l-1.72-.33a1 1 0 0 1-.81-.69.92.92 0 0 1 .27-1 7.45 7.45 0 0 0 2.26-5.1v-1.17A5.09 5.09 0 0 0 19 5a4.8 4.8 0 0 0-1.64.29 1 1 0 1 1-.69-1.88A6.9 6.9 0 0 1 19 3a7.08 7.08 0 0 1 7 7.16v1.18a9.26 9.26 0 0 1-1.73 5.17c5.05 1.21 5.69 4 5.69 6.39V29a1.07 1.07 0 0 1-.96 1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconUserGroupOutlineSVG);
ForwardRef.displayName = "IconUserGroupOutline";
export { ForwardRef as IconUserGroupOutline };
